export default __webpack_public_path__ + "static/media/Skullcracker.16a9ed8b.jpg";